export default {
      id: "flex-justifyContent-space-around-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-justifyContent-space-around-usage",
      toString: function () {
        return this.url;
      }
    }